import { render, staticRenderFns } from "./addTicket.vue?vue&type=template&id=a197dd22"
import script from "./addTicket.vue?vue&type=script&lang=js"
export * from "./addTicket.vue?vue&type=script&lang=js"
import style0 from "./addTicket.vue?vue&type=style&index=0&id=a197dd22&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports